import {useEffect} from 'react'
import {SessionEditModalHeader} from './SessionEditModalHeader'
import {SessionEditModalFormWrapper} from './SessionEditModalFormWrapper'

const SessionEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_content'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal session */}
          <div className='modal-content'>
            <SessionEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <SessionEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal session */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {SessionEditModal}
